export default function ClosingIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_21_60)">
        <path
          d="M1.34961 0.349609L45.6696 46.6796"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M46.6796 1.34961L0.349609 45.6696"
          stroke="black"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_21_60">
          <rect width="47.03" height="47.03" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
